import { Mutex } from "async-mutex";
import routes from "../../routes/routes.path";
import { UserSession } from "../../types/state.types";
import { sessionId } from "../const-cooperativas";
import { decifrarJWT, gerarJWT } from "../jwt";

export type GcoopSession = {
  logged: boolean;
  userData?: UserSession;
};

type GcoopSessionConfig = {
  Nome?: string;
  Endereco?: string;
  Logo?: string;
  CNPJ?: string;
  Configuracoes?: {
    ID: number;
    Descricao: string;
    Valor: string;
  }[];
};

export const tokenKey = "jwt-token-session";

export const ConfigsSet = {
  Cor: 1,
  AgendamentoPreCad: 2,
  EspelhoProducao: 5000,
  RegistroBiometrico: 5001,
  PrevisaoProducao: 5002,
  ExtratoRepasseExterno: 5003,
  ExtratoRepasseExternoV2: 5007,
  ExtratoRepasse: 5004,
  IR: 5005,
  PreCadastro: 5006,
  Procedimentos: 5008,
  DemonstrativoFinanceiro: 5009,
  Documentos: 5010,
};

export const RoutesConfigsIDs: Record<number, string> = {
  5000: routes.EspelhoProducao,
  5001: routes.RegistroBiometrico,
  5002: routes.PrevisaoProducao,
  5003: routes.ExtratoRepasseExterno,
  5007: routes.ExtratoRepasseExternoV2,
  5004: routes.ExtratoRepasse,
  5005: routes.IR,
  5006: routes.PreCadastro,
  5008: routes.Procedimentos,
  5009: routes.DemonstrativoFinanceiro,
  5010: routes.Documentos,
};

const mutex = new Mutex();

export const getSession = async (): Promise<GcoopSession> => {
  const release = await mutex.acquire();

  if (localStorage.getItem("gcoop-area-cooperado-session")) {
    localStorage.removeItem("gcoop-area-cooperado-session");
  }
  const session = localStorage.getItem(
    `gcoop-area-cooperado-session-${sessionId}`
  );
  let gcoopSession: GcoopSession | null;

  if (session && !session.includes(tokenKey)) {
    gcoopSession = JSON.parse(session);
    setSession(gcoopSession!);
  } else if (session) {
    const tokenJWT: string = JSON.parse(session)[tokenKey];
    gcoopSession = await decifrarJWT(tokenJWT);
  } else {
    gcoopSession = { logged: false };
  }

  release();
  return gcoopSession ?? { logged: false };
};

export const setSession = async (session: any) => {
  const release = await mutex.acquire();
  const tokenSession = await gerarJWT(session);

  localStorage.setItem(
    `gcoop-area-cooperado-session-${sessionId}`,
    JSON.stringify({ [tokenKey]: tokenSession })
  );

  release();
  return session;
};

export const getSessionConfig = (): GcoopSessionConfig => {
  if (localStorage.getItem("gcoop-area-cooperado-session-config")) {
    localStorage.removeItem("gcoop-area-cooperado-session-config");
  }
  const sessionConfig = localStorage.getItem(
    `gcoop-area-cooperado-session-config-${sessionId}`
  );

  const gcoopSessionConfig: GcoopSessionConfig = JSON.parse(
    sessionConfig || "{}"
  );

  return gcoopSessionConfig;
};

export const setSessionConfig = (sessionConfig: any) => {
  localStorage.setItem(
    `gcoop-area-cooperado-session-config-${sessionId}`,
    JSON.stringify(sessionConfig)
  );
  return sessionConfig;
};
